import { render } from "./done.html?vue&type=template&id=ef5eb3f8&scoped=true&ts=true"
import script from "./done.ts?vue&type=script&lang=ts"
export * from "./done.ts?vue&type=script&lang=ts"

import "./done.scss?vue&type=style&index=0&id=ef5eb3f8&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5eb3f8"]])

export default __exports__